import React from 'react';
import { observer } from 'mobx-react';
import EmptyState from '../../../components/EmptyState';
var ViewDocumentsDenied = function ViewDocumentsDenied(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(EmptyState, {
    icon: /*#__PURE__*/React.createElement("img", {
      src: require('./icon.svg'),
      alt: "Documents Disabled graphic",
      style: {
        width: 'auto',
        height: 150
      }
    }),
    title: "Documents Disabled"
  }, "Please contact an administrator to allow document permissions.");
};
export default observer(ViewDocumentsDenied);
//# sourceMappingURL=index.js.map
